import { Button, Clickable, Col, Icon, Spinner2, Text } from 'components';
import { Api, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const ShoutoutCheckout = ({ data, preSelected, handleNext, userData, handleBack }) => {
  const [price, setPrice] = useState(null);
  const [needCard, setNeedCard] = useState(false);
  const user = useSelector((state) => state.user);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { currency, cards } = user.billing;
  const { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    getPrice();
  }, []);

  useEffect(() => {
    if (!price || cards?.length) return;
    if (!price.price) return;
    setNeedCard('UpdatePaymentWarning');
  }, [price, preSelected, data]);

  async function getPrice() {
    const res = await Api.get(`/shoutouts/athlete/getPricing/${userData._id}/shoutoutFromAthlete`);
    if (!res) return;

    dispatch({
      type: 'UPDATE_BILLING',
      payload: res.billing
    });

    setPrice({
      country: res.country,
      currency: res.currency,
      amount: res.amount,
      serviceFeePct: res.serviceFeePct,
      athleteFee: res.athleteFee,
      symbol: res.symbol,
      paymentType: res.paymentType,
      athleteId: res.athleteId,
      tierId: res.tierId
    });
  }

  const handleSubmit = async () => {
    setIsLoading(true);
    const res = await Api.post(
      '/shoutouts/athlete/create',
      {
        forSomeone: true,
        athleteId: userData._id,
        name: data?.reqName,
        introduction: data.introduction,
        reason: data.instructions?.option,
        gender: data.gender?.option,
        instruction: data.addInstruction,
        amount: parseFloat(price.amount),
        currency: price?.currency
      },
      'fullScreen'
    );
    setIsLoading(false);
    if (res?.err) {
      dispatch({
        type: 'HANDLE_RES',
        payload: {
          err: 'Price updated! Please refresh the page to view the new amount before booking.'
        }
      });
    } else {
      handleNext();
    }
  };

  return (
    <React.Fragment>
      <Col noFlex pos="relative" top={isMobile ? '-110px' : '-120px'} left="0">
        <Clickable onClick={handleBack}>
          <Col
            // hasBorder='2px solid #000'
            // hasRadius='32px'
            wid="40px"
            ht="40px"
            centerAll
          >
            <Icon type="arrowLeft" dimensions={16} col={theme.GREY_60} />
          </Col>
        </Clickable>
      </Col>

      {isLoading && (
        <Col centerAll noFlex wid="100%" ht="300px">
          <Spinner2 col={theme.SECONDARY} spinnerSize="60px" />
        </Col>
      )}
      {!isLoading && (
        <Col wid="100%" marg="8px 0 0" center between>
          <Col marg="0 0 0" wid="100%" center>
            <Text h2 marg="40px 0 0" col="black">
              {t('requestShoutout.deliveryInfo')}
            </Text>
            {price && (
              <Text h4 marg="30px 0 0" col="black">
                {t('requestShoutout.standard', { price: `${price?.symbol}${price?.amount}` })}
              </Text>
            )}
            <Text marg="2px 0 0" col="black">
              {t('requestShoutout.videoDelivered', { day: '3 - 7' })}
            </Text>
            <div style={{ flex: 1, marginTop: '10px' }}></div>
            <Button
              bg={theme.SECONDARY}
              disabled={!cards?.length || !price}
              text={t('requestShoutout.bookNow')}
              containerStyle={{ marginBottom: 100, marginTop: 50 }}
              onClick={handleSubmit}
            />
          </Col>
        </Col>
      )}
    </React.Fragment>
  );
};

export default ShoutoutCheckout;
